// Admin page - for super admins (Njaal, Matias) and this year's blåtur organizers
// Access is enforced by firestore.rules; this page only hides what you can't do anyway

import React, { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuthUser } from './blaturData';
import { useRoles, loadDirectory, downloadBackup } from './adminData';
import AdminEvents from './AdminEvents';
import AdminPeople from './AdminPeople';
import AdminBlatur from './AdminBlatur';
import AdminMembers from './AdminMembers';
import AdminInviteEmail from './AdminInviteEmail';

const TABS = [
  { key: 'events', label: 'Eventer' },
  { key: 'personer', label: 'Personer' },
  { key: 'medlemmer', label: 'Invitasjonsliste' },
  { key: 'invitasjonsmail', label: 'Invitasjonsmail' },
  { key: 'blatur', label: 'Blåtur-arrangører' },
];

function Admin() {
  const user = useAuthUser();
  const roles = useRoles(user);
  const [searchParams] = useSearchParams();
  const [tab, setTab] = useState(searchParams.get('tab') || 'events');
  const [directory, setDirectory] = useState(null);
  const [backupStatus, setBackupStatus] = useState('');

  const backup = async () => {
    setBackupStatus('Henter data…');
    const counts = await downloadBackup();
    setBackupStatus('Lastet ned: ' + Object.entries(counts).map(([k, v]) => `${k} ${v}`).join(', '));
  };

  const reloadDirectory = useCallback(async () => setDirectory(await loadDirectory()), []);

  useEffect(() => {
    if (roles.isBlaturAdmin) reloadDirectory();
  }, [roles.isBlaturAdmin, reloadDirectory]);

  if (user === undefined || roles.loading) return <div className="admin-page"><p className="admin-hint">Laster…</p></div>;
  if (!user) return <div className="admin-page"><p className="admin-hint">Logg inn for å bruke admin.</p></div>;
  if (!roles.isBlaturAdmin) {
    return (
      <div className="admin-page">
        <p className="admin-hint">Du har ikke admin-tilgang. Den har Njaal, Matias og årets blåtur-arrangører.</p>
        <p className="admin-hint">Du er logget inn som {user.email} (bruker-ID {user.uid}).</p>
      </div>
    );
  }

  const props = { user, roles, directory, reloadDirectory };

  return (
    <div className="admin-page">
      <div className="admin-header">
        <h1>⚙️ Admin</h1>
        <p className="admin-hint">
          {roles.isSuperAdmin ? 'Du har full tilgang.' : `Du er blåtur-arrangør${roles.config?.year ? ` for ${roles.config.year}` : ''}.`}
        </p>
        {roles.isSuperAdmin && (
          <p>
            <button className="admin-btn" onClick={backup}>Last ned backup (JSON)</button>
            {backupStatus && <span className="admin-status"> {backupStatus}</span>}
          </p>
        )}
      </div>

      <div className="admin-tabs">
        {TABS.map(t => (
          <button key={t.key} className={`filter-chip${tab === t.key ? ' active' : ''}`} onClick={() => setTab(t.key)}>{t.label}</button>
        ))}
      </div>

      {!directory ? <p className="admin-hint">Laster…</p> : (
        <>
          {tab === 'events' && <AdminEvents {...props} initialEventId={searchParams.get('event')} />}
          {tab === 'personer' && <AdminPeople {...props} />}
          {tab === 'medlemmer' && <AdminMembers {...props} />}
          {tab === 'invitasjonsmail' && <AdminInviteEmail {...props} />}
          {tab === 'blatur' && <AdminBlatur {...props} />}
        </>
      )}
    </div>
  );
}

export default Admin;
